<template>
  <div style="min-height: 100vh;">
    <PublicHeaderNew />
    <div id="registration-block">
      <div id="form-wrapper">
        <nuxt />
      </div>
    </div>
  </div>
</template>

<script>
import PublicHeaderNew from '~/components/global/PublicHeaderNew'

export default {
  layout: 'registration',
  data() {
    return {}
  },
  components: {
    PublicHeaderNew,
  },
  head() {
    const scripts = [];

    if (process.env.frontendUrl.includes('workera.ai')) {
      scripts.push({ src: 'https://cmp.osano.com/AzqBtjU2KFaQ93EWK/f2679a7f-1db2-481b-9c11-2eb5cb7e3ea9/osano.js' });
    }

    return {
      title: 'Workera - Log in',
      meta: [
        {
          hid: 'login',
          name: 'Workera - Log in',
          content:
            'Log in to your dashboard, get feedback and find great opportunities',
        },
      ],
      script: scripts,
      link: [
        {
          rel: 'canonical',
          href: 'https://workera.ai' + this.$route.path,
        },
      ],
    }
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Assistant:400,700,800&display=swap');
#__nuxt,
#__layout {
  min-height: 100vh;
}

#registration-block {
  min-height: 100vh;
  line-height: 1.2rem;
  font-family: 'Assistant';
  background: #dff5fb;
}

#registration-header {
  padding-right: 10%;
  display: flex;
  align-items: center;
  background: white;
  min-height: 10vh;
}

#registration-header > div:first-child {
  color: #e1e7f3;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
}

#registration-header > div:first-child > div:last-child {
  font-size: 0.9rem;
  font-weight: 400;
}

#hiring-button {
  background-color: white;
  display: flex;
  color: #009fcc;
  align-items: baseline;
  justify-content: center;
  margin-left: auto;
  cursor: pointer;
  border: 1px solid #009fcc;
  border-radius: 2px;
  padding: 0.2rem 2rem;
  font-size: 1.1rem;
}

#login-header {
  padding-left: 3rem;
  padding-right: 3rem;
  padding-top: 1rem;
  display: flex;
}

#login-header > div:first-child {
  color: #e1e7f3;
  font-size: 1.3rem;
  cursor: pointer;
  text-decoration: none;
}

#login-header > div:first-child > div:last-child {
  font-size: 0.7rem;
}

#login-form {
  width: 600px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 5rem;
  padding-bottom: 1rem;
}

#login-form label {
  display: block;
  font-weight: 510;
  margin-top: 3rem;
  margin-bottom: 1rem;
}

#form-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 90vh;
}

#login-form input {
  width: 100%;
  min-height: 3.3rem;
  border-radius: 5px;
  text-indent: 1rem;
  border: 1px solid #00000076;
  font-size: 1.1rem;
  box-shadow: 0 0 0 0 #00000076;
  color: #000000;
  opacity: 0.5;
  line-height: 2rem;
}

#login-title {
  font-size: 1.8rem;
  font-weight: bold;
  text-align: center;
  width: 100%;
  margin-bottom: 1rem;
}

#login-form > div:last-child {
  text-align: center;
  width: 100%;
  margin-top: 2rem;
  margin-bottom: 3rem;
}

#login-button {
  min-height: 3.3rem !important;
}
</style>
